var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const EyeSlash = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-eye_slash ${className}`} {...other}>
      <g>
        <path d="M14.344 5.513l1.312.727a8.77 8.77 0 01-2.508 2.837l1.048 1.047a.5.5 0 01.058.638l-.058.069-.354.353a.5.5 0 01-.638.058l-.069-.058-1.312-1.311a8.726 8.726 0 01-3.073.845V12.5a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5v-1.782a8.726 8.726 0 01-3.058-.838l-1.353 1.352a.5.5 0 01-.707 0l-.353-.354a.5.5 0 010-.707l1.085-1.086A8.768 8.768 0 01.517 6.537l-.149-.254 1.308-.735A7.246 7.246 0 008 9.25a7.245 7.245 0 006.209-3.504l.135-.233z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default EyeSlash;
